import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import { AlertCircle, CheckCircle, CircleArrowLeft, CircleCheckBig, Info } from 'lucide-react';
import * as React from 'react';

const iconStyles = cva('tw-inline-flex tw-mr-1', {
    variants: {
        color: {
            default: 'tw-text-primary',
            seconday: 'tw-text-seconday',
            destructive: 'tw-text-destructive',
            warning: 'tw-text-amber-800',
            success: 'tw-text-green-600',
            info: 'tw-text-sky-800'
        },
        size: {
            small: 'tw-w-4 tw-h-4',
            medium: 'tw-w-6 tw-h-6',
            large: 'tw-w-8 tw-h-8'
        }
    },
    defaultVariants: {
        color: 'default',
        size: 'medium'
    }
});

const iconMap = {
    destructive: AlertCircle,
    warning: AlertCircle,
    success: CircleCheckBig,
    info: Info,
    exclamationCircle: AlertCircle,
    arrowLeftCircle: CircleArrowLeft,
    circleCheck: CheckCircle
};

// Icon component
const Icon = ({ icon, size, color, className = '', ...props }) => {
    const IconComponent = iconMap[icon]; // Get the corresponding icon component
    const iconClassName = clsx(iconStyles({ color, size }), className);

    return IconComponent ? (
        <IconComponent
            className={iconClassName} // Combine styles with custom className
            {...props}
        />
    ) : (
        <span>Invalid icon</span> // Return this when an invalid icon is passed
    );
};

Icon.displayName = 'Icon';

export { Icon };
